import { render, staticRenderFns } from "./Group.List.vue?vue&type=template&id=4ea90572&"
import script from "./Group.List.vue?vue&type=script&lang=js&"
export * from "./Group.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports